let userInteracted = false;

// Mark when user physically interacts
['click', 'change', 'input', 'submit'].forEach(evt => {
	document.addEventListener(evt, () => {
		userInteracted = true;
	}, { once: true });
});

function loadSearchResults(aTagHref = null) {
	const searchForm = document.querySelector('form[action="/search"]');
	const resultsContainer = document.getElementById('results-container');
	const loader = document.getElementById('loader');

	resultsContainer.innerHTML = '';
	if (loader.classList.contains('hidden')) {
		loader.classList.remove('hidden');
	}

	// - listen to page value in url and pass it in the search if not present
	// - only do the animation whne pagination is clicked on

	if (!searchForm || !resultsContainer) return;

	// console.log(aTagHref);

	// Build the URL from form parameters
	const formData = new FormData(searchForm);
	const params = new URLSearchParams(formData);

	// remove stuff we don't want in URL
	params.delete('faceted_redirect');

	// view param is only for the AJAX view
	params.set('view', 'driveelectric/templates/spa-search');

	let fetchUrl = `/search/?${params.toString()}`;

	// URL used for the fetch
	if (aTagHref != null) {
		fetchUrl = aTagHref + '&view=driveelectric/templates/spa-search';
	}

	// console.log('Fetching search results:', fetchUrl);


	// Update browser URL (without the view param if you don't want it in the address bar)
	const urlParamsForBrowser = new URLSearchParams(params);
	urlParamsForBrowser.delete('view');
	const browserUrl = `${window.location.origin}${window.location.pathname}?${urlParamsForBrowser.toString()}`;

	if (window.history && window.history.replaceState && userInteracted) {
		window.history.replaceState({}, '', browserUrl);
	}

	// Fetch the HTML view
	fetch(fetchUrl)
		.then(response => {
			if (!response.ok) throw new Error('Network error');
			return response.text();
		})
		.then(html => {
			loader.classList.add('hidden');
			resultsContainer.innerHTML = html;
			/*if (!userScrolling) {
				resultsContainer.scrollIntoView({ 
					behavior: 'smooth', 
					block: 'start' 
				});
			}*/
			// console.log('Results loaded successfully');

		})
		.catch(err => {
			console.error('Search load failed:', err);
			resultsContainer.innerHTML = '<p class="error">Failed to load search results.</p>';
		});
}

// Search result pagination uses normal navigation. This keeps every existing
// query parameter in the link and ensures the server returns the correctly
// filtered page instead of rebuilding the request from an incomplete form.

let userScrolling = false;
let scrollTimeout = null;

// Detect user scroll
window.addEventListener('scroll', () => {
	userScrolling = true;

	clearTimeout(scrollTimeout);
	scrollTimeout = setTimeout(() => {
		userScrolling = false;
	}, 150);
});
